import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-history",
  "use": "icon-history-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 24 24\" fill=\"none\" id=\"icon-history\">\n    <path fill-rule=\"evenodd\" fill=\"#000000\" d=\"M3 6L21 6L21 4L3 4L3 6ZM3 13L15 13L15 11L3 11L3 13ZM21 20L3 20L3 18L21 18L21 20Z\">\n    </path>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol